import React from 'react'
import RegisterStudent from '../../features/trainer/RegisterStudent'

const RegisterStudentPage = () => {
    
  return (
  <RegisterStudent/>
  )
}

export default RegisterStudentPage